import ApiBase from 'Services/Api/ApiBase';

class DocumentReads extends ApiBase {
    route = '/admin/service-users/:user/document-reads';

    /**
     * @method downloadLog
     * @param {string} user The service user's id.
     * @param {string} filename
     * @return {Promise<*>}
     */
    downloadLog = (user, filename) => this.downloadFile(`/admin/service-users/${user}/document-reads/export`, {}, filename);
}

export default new DocumentReads();
